import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, SimpleListAdapter, TS_DropDown, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ResourceTypes } from '@app/hcs-shared';
import { ModuleFE_Resource } from './ModuleFE_Resource.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
const Props_DropDown = {
    module: ModuleFE_Resource,
    modules: [ModuleFE_Resource],
    mapper: item => [item.label],
    placeholder: 'Choose a Resource',
    renderer: item => _jsx(_Fragment, { children: item.label })
};
export const DropDown_Resource = GenericDropDownV3.prepare(Props_DropDown);
const Props_ResourceTypeDD = {
    adapter: SimpleListAdapter(ResourceTypes, item => _jsx(_Fragment, { children: item.item })),
    placeholder: 'Select Resource Type',
    caret: DropDown_DefaultCaret
};
export const DropDown_ResourceType = TS_DropDown.prepare(Props_ResourceTypeDD);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_Resource,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete }), item.label] });
    },
    uiSelector: DropDown_Resource.selectable,
});
export const MultiSelect_Resource = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map